import { isWysiwygEditorCaretOverElement } from '../../../WysiwygEditor'

export function isEmailReplyFormCaretUnderButton({ button, editor }) {
  return (
    Boolean(button) &&
    editor.hasFocus() &&
    isWysiwygEditorCaretOverElement(editor, button)
  )
}
